export const DOWNLOAD_LINKS = {
  IOS: 'https://apps.apple.com/us/app/pari/id1616258583',
  ANDROID: 'https://play.google.com/store/apps/details?id=mx.pari.tech',
};
